import { useIntl } from 'react-intl';

import { useAnalytics } from '@/hooks/analytics';
import { useDeviceState } from '@/hooks/store';
import genericMessages from '@/messages/messages';
import { CALM_ONE_LINKS } from '@/utils/deeplinks/deeplinks';

import { Message } from '../../shared/data';
import { StyledButton } from './styles';

const SuccessButton = ({
	successCTAUrl,
	partnerMessages,
}: {
	successCTAUrl: string | undefined;
	partnerMessages?: {
		successCTA?: Message;
	};
}) => {
	const { formatMessage } = useIntl();
	const { logEvent } = useAnalytics();
	const device = useDeviceState();

	function onCtaClick(): void {
		const url = successCTAUrl ?? CALM_ONE_LINKS.app;

		logEvent({
			eventName: 'Success : CTA : Clicked',
			eventProps: {
				url,
			},
		});
		window.location.assign(url);
	}

	function getCTAButtonLabel(): Message {
		if (partnerMessages?.successCTA) {
			return partnerMessages?.successCTA;
		}
		return device.isMobile ? genericMessages.downloadCalmApp : genericMessages.openCalmApp;
	}

	return (
		<StyledButton onPress={onCtaClick} role="link">
			{formatMessage(getCTAButtonLabel())}
		</StyledButton>
	);
};

export default SuccessButton;
